/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Table_NameInputs */

const es_settings_dirs_table_name = /** @type {(inputs: Settings_Dirs_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const en_settings_dirs_table_name = /** @type {(inputs: Settings_Dirs_Table_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Settings_Dirs_Table_NameInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_table_name = /** @type {((inputs?: Settings_Dirs_Table_NameInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Table_NameInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_table_name(inputs)
	return en_settings_dirs_table_name(inputs)
});
export { settings_dirs_table_name as "settings.dirs.table.name" }